import { render, staticRenderFns } from "./PostalCodeDashboard.vue?vue&type=template&id=4cd5e380"
import script from "./PostalCodeDashboard.vue?vue&type=script&lang=js"
export * from "./PostalCodeDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports